import { CircularProgress, IconButton } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addDoc, collection } from "firebase/firestore";
import { db } from "firebaseApp";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { createConversation } from "utils/conversations";
import { modalsActions } from "store/react-lib/generic-ui/modals";
import { popupActions } from "store/react-lib/generic-ui/popup";
import AttachFileModal from "./AttachFileModal";
import AddLinkIcon from '@mui/icons-material/AddLink';
import { useNavigate, useParams } from "react-router-dom";
const MODAL_NAME = "attachFileToConversationModal";

export default function AttachFileIconButton({
  buttonProps = {},
}) {
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useAuth();
  const params = useParams();
  const botState = useSelector((state) => state.bot);

  const [attaching, setAttaching] = useState(false);

  const handleOpen = async () => {
    try {
      dispatch(modalsActions.openModal(MODAL_NAME));
    } catch (error) {
      console.log(error);
    }
  };

  const attachFileToConversation = async ({ fileId, fileData }) => {
    try {
      setAttaching(true);
      let conversationId = params.conversationId;
      if (!conversationId) {
        const conversation = await createConversation(
          botState.current,
          auth.currentUser.uid,
          dispatch
        );
        conversationId = conversation.id;
        navigate(`/${conversationId}`);
      }
      const payload = {
        ...fileData,
        fileId,
        botId: botState.current,
        targetId: conversationId,
      };
      console.log(payload);
      await addDoc(collection(db, "attachments"), payload);
      dispatch(modalsActions.closeModal(MODAL_NAME));
    } catch (error) {
      console.log(error);
      dispatch(
        popupActions.showError("Couldn't attach file. Try again later.")
      );
    } finally {
      setAttaching(false);
    }
  };

  return (
    <>
      <AttachFileModal
        name={MODAL_NAME}
        successCallback={attachFileToConversation}
      />
      <IconButton
        onClick={handleOpen}
        data-testid="attach-file-button"
        {...buttonProps}
        disabled={attaching}
      >
        {attaching ? <CircularProgress size={24} /> : <AddLinkIcon />}
      </IconButton>
    </>
  );
}
